// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"_4374c4e","infoBox":"_e1b1376","subtitleText":"_c00584e","infoText":"_1b03b1a","arrowContainer":"_740de6f","arrow":"_984dc6d","active":"_a238792"};